<template>
  <div class="pma-wait-times graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">High-risk devices are being approved faster in the US</h3>
    <p v-if="showDeck">The average time that it takes the Food and Drug Administration to review and approve a device through its pre-market approval process has dropped by more than 200 days since 1996.</p>
    <line-chart :chart-height-ratio="baseHeightRatio" :chart-data="data" :chart-options="options"></line-chart>
    <p class="graphic-source">Note: This chart shows the time, in days, between an application being received by the FDA and the device being approved. Source: U.S. Food and Drug Administration, ICIJ and AP analysis</p>
  </div>
</template>

<script>
import data from '../assets/pma-wait-times.json'
import LineChart from '@/components/LineChart.vue'
import embeddable from '../mixins/embeddable'

const options = {
  chartName: "pma-wait-times",
  seriesName: "waitTime",
  labelWidth: 30,
  dateFormat: "%Y",
  yAxisTickFormat: function(d) {return d;},
  yAxisTicks: 5,
}

export default {
  name: 'PmaWaitTimes',
  mixins: [embeddable],
  components: {
    LineChart,
  },
  data() {
    return {
      data,
      options
    }
  }
}
</script>
